
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.1 2.8a3.6 3.6 0 00-3.598 3.692.9.9 0 01-.675.893A2.702 2.702 0 005.5 12.7h.9a.9.9 0 110 1.8h-.9a4.5 4.5 0 01-1.773-8.636 5.4 5.4 0 0110.052-2.16A5.4 5.4 0 0113.6 14.5a.9.9 0 110-1.8 3.6 3.6 0 10-.294-7.188.9.9 0 01-.9-.54A3.601 3.601 0 009.102 2.8zm.9 5.4a.9.9 0 01.9.9v6.828l.265-.264a.9.9 0 011.272 1.272l-1.8 1.8a.9.9 0 01-1.272 0l-1.8-1.8a.9.9 0 111.272-1.272l.264.264V9.1a.9.9 0 01.9-.9z"}})])
          )
        }
      }
    